import React from 'react';
import './ui.scss';

export const Textarea = ({ label, className = '', id, required, ...props }) => {
  const inputId = id || (label ? label.replace(/\s+/g, '-').toLowerCase() : undefined);
  return (
    <div className={className}>
      {label && (
        <label className="builder-label" htmlFor={inputId}>
          {label}
          {required && <span className="builder-label__required" aria-hidden="true">*</span>}
        </label>
      )}
      <textarea id={inputId} className="builder-ui-textarea" required={required} {...props} />
    </div>
  );
};

export default Textarea;
